<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.name_of_collector')">
              <a-select v-model='queryParam.userName' optionFilterProp="children" showSearch allowClear>
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'userMobile')">
              <a-input :placeholder="$t(I18N_KEY.COLLECTION + 'userMobilePlaceholder')"
                v-model='queryParam.sysmobile'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'createTime')">
              <a-range-picker v-model='queryParam.endTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="6">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'countDays')">
              <a-select v-model="queryParam.countDays" :placeholder="$t(I18N_KEY.COLLECTION + 'countDaysPlaceholder')"
                style="width: 100%;">
                <a-select-option :value="3">3天</a-select-option>
                <a-select-option :value="5">5天</a-select-option>
                <a-select-option :value="7">7天</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="6">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'viewField')">
              <a-select v-model="queryParam.viewFieldFlag" style="width: 100%;">
                <a-select-option :value="1">催回成功率</a-select-option>
                <a-select-option :value="2">催回成功率(金额)</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.grouping')">
              <a-select v-model='queryParam.groupId' allowClear>
                <a-select-option v-for='item in groupList' :key='item.id'>
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select default-value='' style='width: 190px' v-model='queryParam.normalConfigId' allowClear>
                <a-select-option v-for='item in normalConfigList' :key='item.id'>
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
              }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='download' style='margin-left: 8px'>{{
                $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div style="overflow-x: auto; width: 100%;">
        <a-table ref='table' :rowKey="record => record.userId + ':' + record.groupKey" size='middle' :columns='columns'
          :dataSource='sortedData' :pagination='false' :loading='loading' :scroll="{ x: 'max-content' }" bordered
          @change="handleTableChange">
          <!-- 固定列自定义渲染（如 userName 宽度） -->
          <template slot='userName' slot-scope='text, record'>
            <div style='width: 220px !important;'>{{ record.userName }}</div>
          </template>

          <!-- 动态新增列的插槽 -->
          <template v-for='col in dynamicColSlots' :slot='col.slotName' slot-scope='text, record'>
            {{ getCellValue(record, col.columnKey) }}
          </template>
        </a-table>
      </div>

    </div>

    <v-modal v-model='visible' :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail v-if='visible' :orderId='orderId' :custInfoId='custInfoId' :taskId='taskId'
          :auditDrawer='false' @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getCollectionPerformanceByStatisticalDate, getSysGroup } from '@/webpublicapi/platformCollection'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import CollectionDetail from './CollectionDetail'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import { exportFileByPost } from '@/api/exportFile'
import { getCollectorName } from '@/webpublicapi/collection'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    CollectionDetail
  },
  data() {
    return {
      CollectorNameList: [],
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      deadlineConfigList: [],
      // 动态列所需数据
      rowMap: {},
      resultMap: {},
      queryParam: {
        endTime: [moment(), moment()],
        settleTime: [],
        userName: undefined,
        sysmobile: undefined,
        departmentId: undefined,
        groupId: undefined,
        normalConfigId: undefined,
        orderType: undefined,
        loanCountFlag: undefined,
        durations: undefined,
        countDays: 7,
        viewFieldFlag: 1
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      sortedData: [],      // 排序后展示的数据
      sortField: null,     // 当前排序的字段（即 columnKey，如 '3'）
      sortOrder: null,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      const baseColumns = [
        {
          title: this.$t('collection.userMobile') || '催收员账号',
          align: 'left',
          dataIndex: 'mobile',
          key: 'mobile',
        },
        {
          title: this.$t('collection.userName') || '用户名',
          align: 'left',
          dataIndex: 'userName',
          key: 'userName',
          width: 120,
          scopedSlots: { customRender: 'userName' },
        },
        {
          title: this.$t('collection.userId') || '用户ID',
          align: 'left',
          dataIndex: 'userId',
          key: 'userId',
        },
      ];

      const rowMap = this.rowMap || {};
      // 提取所有键，转换为数字排序以保证显示顺序
      const sortedKeys = Object.keys(rowMap).map(Number).sort((a, b) => a - b);
      // 动态列：所有 rowMap 中的键都作为列（不再限制数量，后端返回多少就展示多少）
      sortedKeys.forEach(key => {
        baseColumns.push({
          title: rowMap[key],
          align: 'center',
          dataIndex: `dynamic_${key}`,
          key: `col_${key}`,
          scopedSlots: { customRender: `col_${key}` },
          width: 150,
          sorter: true,
          sortOrder: this.sortField === String(key) ? this.sortOrder : null,
        });
      });

      return baseColumns;
    },
    dynamicColSlots() {
      const rowMap = this.rowMap || {};
      const sortedKeys = Object.keys(rowMap).map(Number).sort((a, b) => a - b);
      return sortedKeys.map(key => ({
        slotName: `col_${key}`,
        columnKey: key,   // 传递 key 用于取值
      }));
    },
  },
  created() {
    this.getDict()
    getSysGroup().then(res => {
      this.groupList = res.data || []
    })
    getCollectionListDepartment().then(res => {
      this.departmentList = res.data || []
    })
    getAllNormalConfig().then(res => {
      this.normalConfigList.push({
        name: '全部',
        id: '',
        value: ''
      })
      res.data.forEach(item => {
        this.normalConfigList.push(item)
      })
    })
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
    getCollectorName().then(res => {
      const keys = Object.keys(res.data)
      for (const key of keys) {
        this.CollectorNameList.push({
          key: key,
          value: res.data[key]
        })
      }
    })
  },
  methods: {
    getColumnTitle(field) {
      const titleMap = {
        mobile: this.$t('collection.mobile') || '催收员账号',
        userName: this.$t('collection.userName') || '用户名',
        userId: this.$t('collection.userId') || '用户ID'
      }
      return titleMap[field] || field
    },
    getCellValue(record, columnKey) {
      const key = `${record.userId}:${columnKey}`;
      return this.resultMap[key] || '-';
    },
    searchQuery() {
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = this.getQueryParams()
      getCollectionPerformanceByStatisticalDate(Object.assign({}, params))
        .then((res) => {
          let response
          if (typeof res === 'string') {
            // 去除 BOM 头并解析
            const cleanStr = res.replace(/^\uFEFF/, '')
            try {
              response = JSON.parse(cleanStr)
            } catch (e) {
              console.log('JSON 解析失败，尝试修复', e);
              // 降级：使用 new Function（容错尾逗号等）
              try {
                response = new Function('return ' + cleanStr)()
              } catch (e2) {
                this.$message.error('响应数据格式错误')
                return
              }
            }
          } else {
            response = res
          }

          if (response.code === 1000) {
            const { dataList, resultMap, rowMap } = response.data || {}
            this.dataSource = dataList || []
            this.rowMap = rowMap || {}
            this.resultMap = resultMap || {}
            this.sortedData = [...this.dataSource]
            if (this.sortField && this.sortOrder) {
              this.performSort()
            }
          } else {
            this.dataSource = []
            this.rowMap = {}
            this.resultMap = {}
            this.$message.error(response.msg || '查询失败')
          }
        })
        .catch((err) => {
          this.$message.error(err.message || '网络错误')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange(pagination, filters, sorter) {
      // 只处理动态列的排序（字段名以 'dynamic_' 开头）
      if (sorter.field && sorter.field.startsWith('dynamic_')) {
        const fieldKey = sorter.field.replace('dynamic_', '')
        this.sortField = fieldKey
        this.sortOrder = sorter.order  // 'ascend' 或 'descend'
      } else {
        // 点击其他列或无排序时清除状态
        this.sortField = null
        this.sortOrder = null
      }
      this.performSort()
    },

    performSort() {
      if (!this.sortField || !this.sortOrder) {
        this.sortedData = [...this.dataSource]
        return
      }

      const columnKey = this.sortField // 例如 '3'
      const order = this.sortOrder === 'ascend' ? 'asc' : 'desc'
      const resultMap = this.resultMap

      // 深拷贝一份数据用于排序
      const dataToSort = [...this.dataSource]

      dataToSort.sort((a, b) => {
        const keyA = `${a.userId}:${columnKey}`
        const keyB = `${b.userId}:${columnKey}`
        let valA = resultMap[keyA]
        let valB = resultMap[keyB]

        // 处理空值/非数字的情况，置于末尾或根据业务调整
        if (valA === undefined || valA === null) valA = ''
        if (valB === undefined || valB === null) valB = ''

        // 尝试转换为数字比较（如 "123.45" -> 123.45）
        const numA = parseFloat(valA)
        const numB = parseFloat(valB)
        if (!isNaN(numA) && !isNaN(numB)) {
          return order === 'asc' ? numA - numB : numB - numA
        }

        // 字符串比较
        const strA = String(valA)
        const strB = String(valB)
        return order === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA)
      })

      this.sortedData = dataToSort
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const data = {
        ...this.queryParam,
        endDateStart: endTime && endTime.length ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: endTime && endTime.length ? this.transformTime(endTime[1]) : undefined
      }
      delete data.endTime
      delete data.settleTime
      return filterObj(data)
    },
    searchReset() {
      this.queryParam.endTime = [moment(), moment()]
      this.queryParam.settleTime = []
      this.queryParam.userName = undefined
      this.queryParam.sysmobile = undefined
      this.queryParam.departmentId = undefined
      this.queryParam.groupId = undefined
      this.queryParam.normalConfigId = undefined
      this.queryParam.orderType = undefined
      this.queryParam.loanCountFlag = undefined
      this.queryParam.durations = undefined
      this.queryParam.countDays = 7
      this.queryParam.viewFieldFlag = 1
      this.sortField = null
      this.sortOrder = null
      this.sortedData = [...this.dataSource]
    },
    async downLoadData() {
      const params = this.getQueryParams()
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/platform/collectionTask/performanceByStatisticalDateExcel`,
          params,
          "催收绩效统计表_" + params.endDateStart + "_" + params.endDateEnd + ".xlsx"
        )
        if (result instanceof Error) {
          this.$message.error(result.message)
        }
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    // 以下为原代码中保留但未使用的方法（如需要可保留）
    succedRatesort(a, b) {
      const rateA = parseFloat(a.succedRate) || 0
      const rateB = parseFloat(b.succedRate) || 0
      return rateA - rateB
    },
    // 字典相关（原代码中有 getDict 方法未提供，可根据实际情况补充）
    getDict() {
      // 如果项目中有字典加载逻辑请补充
    },
    CollectorNameListChange(e) {
      console.log('下拉框发生变化', e)
    },
    onChangeOne(value) {
      getSysGroup({ departmentId: value }).then(res => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    }
  }
}
</script>

<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>